import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {AuthService} from '../services/auth-service';

export const apiCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  return next(req.clone({
    withCredentials: true
  })).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status != 404 && error.status != 500 && req.url !== `${environment.apiUrl}/auth/logout`) {
        authService.handleSessionExpired();
      }
      console.log(error);
      return throwError(() => error);
    })
  );
};
